import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import { HourAndMinutesProps as Props } from '../../../../shared/types/props/progressBar';

const getStyleByPosition = (position: string, live?: boolean) => {
  switch (position) {
    case 'left':
      return {
        bottom: `${24 * Screen.widthRatio}px`,
      };
    case 'start':
      return {
        bottom: `${-10 * Screen.widthRatio}px`,
        right: live ? '102%' : '103%',
      };
    case 'time':
      return {
        bottom: `${28 * Screen.widthRatio}px`,
        right: `${(live ? -55 : -35) * Screen.widthRatio}px`,
        'text-align': 'center',
      };
    case 'end':
      return {
        bottom: `${-10 * Screen.widthRatio}px`,
        left: '102%',
      };
    case 'right':
      return {
        bottom: `${24 * Screen.widthRatio}px`,
        right: '0',
      };
  }
};

const HourAndMinutes = styled.div<Props>`
  position: absolute;
  fonts: ${Fonts['light']};
  ${(props) => {
    return getStyleByPosition(props?.position, props?.live);
  }}
  pointer-events: none;
  width: ${100 * Screen.widthRatio}px;
`;

export default HourAndMinutes;
